import it from '../translations/it.json';
export default it;



// WEBPACK FOOTER //
// ./~/@99designs/globalnav/locale-data/it.js